<nb-select fullWidth [(selected)]="value" [disabled]="isDisabled">
  <nb-option *ngIf="showEmptyOption" [value]="null">Alle</nb-option>
  <nb-option *ngFor="let option of InsuranceCompany" [value]="option">{{ option | insuranceCompanyTranslation }}</nb-option>
</nb-select>
